// Form names
export const LOAD_PRODUCT_TREES = 'LOAD_PRODUCT_TREES'
export const LOAD_PRODUCT_TREES_SUCCESS = 'LOAD_PRODUCT_TREES_SUCCESS'
export const LOAD_PRODUCT_TREES_FAILED = 'LOAD_PRODUCT_TREES_FAILED'

export const LOAD_PRODUCT_TREE = 'LOAD_PRODUCT_TREE'
export const LOAD_PRODUCT_TREE_SUCCESS = 'LOAD_PRODUCT_TREE_SUCCESS'
export const LOAD_PRODUCT_TREE_FAILED = 'LOAD_PRODUCT_TREE_FAILED'

export const COPY_PRODUCT_TREE = 'COPY_PRODUCT_TREE'
export const COPY_PRODUCT_TREE_SUCCESS = 'COPY_PRODUCT_TREE_SUCCESS'
export const COPY_PRODUCT_TREE_FAILED = 'COPY_PRODUCT_TREE_FAILED'

export const CREATE_SUPPORT_GROUP_CATEGORY = 'CREATE_SUPPORT_GROUP_CATEGORY'
export const CREATE_SUPPORT_GROUP_CATEGORY_SUCCESS = 'CREATE_SUPPORT_GROUP_CATEGORY_SUCCESS'
export const CREATE_SUPPORT_GROUP_CATEGORY_FAILED = 'CREATE_SUPPORT_GROUP_CATEGORY_FAILED'

export const UPDATE_SUPPORT_GROUP_CATEGORY = 'UPDATE_SUPPORT_GROUP_CATEGORY'
export const UPDATE_SUPPORT_GROUP_CATEGORY_SUCCESS = 'UPDATE_SUPPORT_GROUP_CATEGORY_SUCCESS'
export const UPDATE_SUPPORT_GROUP_CATEGORY_FAILED = 'UPDATE_SUPPORT_GROUP_CATEGORY_FAILED'

export const DELETE_SUPPORT_GROUP_CATEGORY = 'DELETE_SUPPORT_GROUP_CATEGORY'
export const DELETE_SUPPORT_GROUP_CATEGORY_SUCCESS = 'DELETE_SUPPORT_GROUP_CATEGORY_SUCCESS'
export const DELETE_SUPPORT_GROUP_CATEGORY_FAILED = 'DELETE_SUPPORT_GROUP_CATEGORY_FAILED'

export const SET_SUPPORT_GROUP_TRANSLATION = 'SET_SUPPORT_GROUP_TRANSLATION'
export const SET_SUPPORT_GROUP_TRANSLATION_SUCCESS = 'SET_SUPPORT_GROUP_TRANSLATION_SUCCESS'
export const SET_SUPPORT_GROUP_TRANSLATION_FAILED = 'SET_SUPPORT_GROUP_TRANSLATION_FAILED'

export const EXPORT_PRODUCT_TREE = 'EXPORT_PRODUCT_TREE'
export const EXPORT_PRODUCT_TREE_SUCCESS = 'EXPORT_PRODUCT_TREE_SUCCESS'
export const EXPORT_PRODUCT_TREE_FAILED = 'EXPORT_PRODUCT_TREE_FAILED'

export const IMPORT_PRODUCT_TREE = 'IMPORT_PRODUCT_TREE'
export const IMPORT_PRODUCT_TREE_SUCCESS = 'IMPORT_PRODUCT_TREE_SUCCESS'
export const IMPORT_PRODUCT_TREE_FAILED = 'IMPORT_PRODUCT_TREE_FAILED'

export const FORMS = {
  data: 'TREE_DATA',
  maingroup: 'TREE_MAIN_GROUP',
  subgroup: 'TREE_SUB_GROUP',
  subgroup_edit: 'TREE_SUB_GROUP_EDIT'
}
